import { render } from "./WidgetBhagSeiteMerken.vue?vue&type=template&id=eb6b81cc&scoped=true&ts=true"
import script from "./WidgetBhagSeiteMerken.vue?vue&type=script&lang=ts"
export * from "./WidgetBhagSeiteMerken.vue?vue&type=script&lang=ts"

import "./WidgetBhagSeiteMerken.vue?vue&type=style&index=0&id=eb6b81cc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb6b81cc"]])

export default __exports__